/* Shared dimension parsing for the picker and custom-size estimates. No product prices are changed. */
(function (root) {
  'use strict';
  function parse(title) {
    var raw = String(title || '').toLowerCase().replace(/[×✕]/g, 'x').replace(/[’‘′]/g, "'").replace(/[“”″]/g, '"');
    if (/custom|inbox|message/.test(raw)) return { group: 'Custom', area: Infinity };
    if (/swatch|sample/.test(raw)) return { group: 'Swatch', area: 0 };
    var primary = raw.split('/')[0];
    var parts = primary.split('x');
    var metric = /cm/.test(primary) && !/ft|feet|foot|'/.test(primary.split('cm')[0]);
    function dimension(part) {
      var m = part.match(/(\d+(?:\.\d+)?)(?:\s*(?:ft\.?|feet|foot|')\s*(\d+(?:\.\d+)?)\s*(?:in\.?|"))?/);
      if (!m) return 0;
      var value = Number(m[1]) + Number(m[2] || 0) / 12;
      return metric ? value / 30.48 : value;
    }
    var round = /round|diameter/.test(primary), square = /square/.test(primary);
    var w = dimension(parts[0]), l = parts.length > 1 ? dimension(parts[1]) : round || square ? w : 0;
    if (!(w > 0 && l > 0)) return { group: 'Other', area: Infinity };
    var group = round ? 'Round' : square || Math.abs(w-l) < 0.001 ? 'Square' : /runner/.test(primary) || Math.min(w,l) <= 3 && Math.max(w,l) / Math.min(w,l) >= 2 ? 'Runner' : 'Rectangular';
    var bundle = raw.match(/\+\s*\d+\s*cushions?/);
    return { group: group, width: w, length: l, area: w*l, bundle: bundle ? bundle[0] : '', metric: metric };
  }
  var groups = ['Swatch', 'Rectangular', 'Square', 'Round', 'Runner', 'Other'];
  function compare(a,b) {
    return groups.indexOf(a.group)-groups.indexOf(b.group) || a.area-b.area || a.width-b.width || a.length-b.length;
  }
  function feet(value) {
    var inches = Math.round(value * 12), whole = Math.floor(inches/12), extra = inches%12;
    return whole + "'" + (extra ? ' ' + extra + '"' : '');
  }
  function label(size) {
    if (!size.width) return '';
    var metric = Math.round(size.width*30.48) + (size.group === 'Round' ? '' : ' × '+Math.round(size.length*30.48)) + ' cm';
    return feet(size.width) + (size.group === 'Round' ? ' round' : ' × '+feet(size.length)) + ' (≈ '+metric+')' + (size.bundle ? ' '+size.bundle : '');
  }
  function customPrice(rateMinorUSD, group, widthFt, lengthFt) {
    if (![rateMinorUSD,widthFt,lengthFt].every(function(n){return Number.isFinite(n) && n>0;})) return null;
    var multiplier=widthFt>20 ? 1.2 : widthFt>=15 ? 1.15 : widthFt>10 ? 1.1 : 1;
    var area=widthFt*(group==='Round' || group==='Square' ? widthFt : lengthFt);
    // Preserve the ERP's existing round cutting premium and $...9 price rounding.
    var dollars=rateMinorUSD*area*multiplier*(group==='Round' ? 1.1 : 1)/100;
    return (Math.ceil((Math.ceil(dollars-1e-8)-9)/10)*10+9)*100;
  }
  var api={parse:parse,compare:compare,label:label,customPrice:customPrice,groups:groups};
  if(typeof module !== 'undefined' && module.exports) module.exports=api;
  else root.IndiaLivingSizes=api;
})(typeof window !== 'undefined' ? window : this);
